export const moveToTop = (
  container: Element,
  node: ChildNode,
  fromTop: number
) => {
  const overlayElements = Array.from(container.childNodes);
  const idx = overlayElements.indexOf(node as ChildNode);
  if (idx === -1) return;
  overlayElements.splice(idx, 1);
  overlayElements.splice(overlayElements.length - fromTop, 0, node);
  container.replaceChildren(...overlayElements);
};

export const createCustomTaskPosition = ({
  id,
  name,
  iconUrl,
  isVisible,
  isAddTaskMode,
  showTasknameVisibility,
  onClick
}: {
  id: string;
  name: string;
  iconUrl: string;
  isVisible: boolean;
  isAddTaskMode: boolean;
  showTasknameVisibility?: boolean;
  onClick?: (id: string, action: 'right-click' | 'left-click') => void;
}) => {
  const taskContainer = document.createElement('div');
  taskContainer.classList.add('task-container');
  !isAddTaskMode && taskContainer.classList.add('expanded');
  !isVisible && taskContainer.classList.add('d-none');
  taskContainer.id = `taskContainer-${id}`;

  const iconContainer = document.createElement('div');
  iconContainer.classList.add('icon-container');
  const iconCircle = document.createElement('div');
  iconCircle.classList.add('icon-circle');

  const icon = document.createElement('img');
  icon.id = `icon-${id}`;
  icon.src = iconUrl;
  icon.alt = 'icon';
  icon.draggable = false;
  icon.classList.add('icon-img');
  iconCircle.append(icon);
  iconContainer.append(iconCircle);

  const detailTaskContainer = document.createElement('div');
  detailTaskContainer.classList.add('detail-task-container');
  detailTaskContainer.id = `detailTaskContainer-${id}`;

  const taskName = document.createElement('span');
  taskName.classList.add('d-none', 'fw-bold');
  taskName.id = `taskName-${id}`;
  taskName.innerHTML = name;

  detailTaskContainer.append(taskName);

  if (showTasknameVisibility !== undefined) {
    taskContainer.classList.remove('expanded');
    detailTaskContainer.classList.add('hidden');
    if (!showTasknameVisibility || isAddTaskMode) {
      taskName.classList.add('d-none');
    } else {
      taskName.classList.remove('d-none');
      taskContainer.classList.add('expanded');
      detailTaskContainer.classList.add('visible');
      detailTaskContainer.classList.remove('hidden');
    }
  }

  // moving this task container element to top of all task containers
  taskContainer.addEventListener('mousedown', (event) => {
    if (event.button !== 0) return;

    const container = document.querySelector('.ol-overlaycontainer-stopevent');
    if (container) {
      container.childNodes.forEach((node) => {
        if (node.contains(taskContainer)) {
          moveToTop(container, node, 3);
          onClick?.(id, 'left-click');
        }
      });
    }
  });

  taskContainer.addEventListener('contextmenu', (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClick?.(id, 'right-click');

    const container = document.querySelector('.ol-overlaycontainer-stopevent');
    const popup = document.querySelector('.ol-popup:has([id^="task-menu"])');
    if (container && popup) {
      const button = popup.querySelector('button.closeBox');
      if (button) button.remove();

      container.childNodes.forEach((node) => {
        if (node.contains(taskContainer)) {
          moveToTop(container, node, 4);
        }
      });

      moveToTop(container, popup, 3);
    }
  });

  const centerDotContainer = document.createElement('div');
  centerDotContainer.classList.add('task-dot-container');
  const centerDot = document.createElement('span');
  centerDot.classList.add('task-center-dot', 'none');
  centerDotContainer.append(centerDot);

  taskContainer.append(iconContainer, detailTaskContainer, centerDotContainer);
  return taskContainer;
};
